import { useTranslation } from 'react-i18next';
import { ContractTemplate } from '../../../hooks/useContractTemplate';
import Card from '../../../components/Card/Card';
import InputShortText from '../../../components/InputShortText/InputShortText';
import TextArea from '../../../components/TextArea/TextArea';
import Subtitle from '../../../components/Subtitle/Subtitle';
import TinyText from '../../../components/TinyText/TinyText';
import { isValidText } from '../../../shared/validation';

type Props = {
  contractTemplate: ContractTemplate;
  updateContractTemplate: (value: any) => void;
};

export default function GeneralSection({ contractTemplate, updateContractTemplate }: Props) {
  const { t } = useTranslation();

  return (
    <Card>
      <>
        <Subtitle text={t('contract_template.general.title')} />
        <TinyText text={t('contract_template.general.hint')} />
        <div className="flex space-x-3">
          <InputShortText
            defaultValue={contractTemplate?.general?.companyName}
            label={t("contract_template.general.company_name")!}
            onChange={(c) => 
              updateContractTemplate({
                general: { ...contractTemplate.general, companyName: c.target.value },
              })
            }
          />
          <InputShortText
            defaultValue={contractTemplate?.general?.taxID}
            label={t("contract_template.general.company_tax_id")!}
            onChange={(c) =>
              updateContractTemplate({
                general: { ...contractTemplate.general, taxID: c.target.value },
              })
            }
          />
        </div>

        <TextArea
          validationFn={value => !!value && isValidText(value, 5)}
          defaultValue={contractTemplate?.general?.companyAddress}
          label={t("contract_template.general.company_address")!}
          onChange={(c) =>
            updateContractTemplate({
              general: { ...contractTemplate.general, companyAddress: c.target.value },
            })
          }
        />
      </>
    </Card>
  );
}

